import { useLanguage } from "../i18n/LanguageContext";
import { INSTAGRAM_URL } from "../constants";
import Button from "../components/Button";
import heroImage from "../assets/hero-image.jpg";
import "./Home.css";

function Home() {
  const { t } = useLanguage();

  return (
    <main className="Home">
      <section className="Hero">
        <h1 className="Hero-title">
          {t("hero.titleLine1")}
          <br />
          {t("hero.titleLine2")}
        </h1>

        <div className="Hero-image-wrap">
          <img
            src={heroImage}
            alt="Raiz pop-up kitchen in action"
            className="Hero-image"
          />
          <div className="Hero-cta-group">
            <Button href={INSTAGRAM_URL} variant="solid">
              {t("hero.ctaPrimary")}
            </Button>
            <Button href={INSTAGRAM_URL} variant="cream">
              {t("hero.ctaSecondary")}
            </Button>
          </div>
        </div>
      </section>
    </main>
  );
}

export default Home;
